import { useContext } from 'react';
import { TSize } from '@src/types/misc';
import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';

type MeasurementType = 'px' | '%';

interface Config {
  hopefulDimensions: TSize;
  returnMeasurementType: MeasurementType;
}

type Generator = (config: Config) => TSize;

function useConstrainedPageItemDimensions(): Generator {
  const { snapEdges, renderRect } = useContext(WysiwygEditorStateContext);

  return function constrainedPageItemDimensions({
    hopefulDimensions,
    returnMeasurementType
  }) {
    const heightWidthRatio = hopefulDimensions.height / hopefulDimensions.width;
    const maxHeight = Math.min(
      renderRect.height * (snapEdges.bottom - snapEdges.top),
      hopefulDimensions.height
    );

    const maxWidth = Math.min(
      renderRect.width * (snapEdges.right - snapEdges.left),
      hopefulDimensions.width
    );

    let calculatedWidth = maxHeight / heightWidthRatio;
    let calculatedHeight = maxHeight;

    if (calculatedWidth > maxWidth) {
      calculatedWidth = maxWidth;
      calculatedHeight = calculatedWidth * heightWidthRatio;
    }

    const dimensions = {
      height: calculatedHeight / renderRect.height,
      width: calculatedWidth / renderRect.width
    };

    if (returnMeasurementType === 'px') {
      dimensions.height = dimensions.height * renderRect.height;
      dimensions.width = dimensions.width * renderRect.width;
    }

    return dimensions;
  };
}

export default useConstrainedPageItemDimensions;
